import * as moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import ReactToPrint from 'react-to-print';
import { Button, Input } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  Row,
  RSelect
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import { GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useRecoilState } from "recoil";
import Table from "../../components/react-table/Table";
import { getToken, set } from "../../helper/auth";
import { popupCustomerFlowAtom } from "../../state";
import { EXTERNAL_PORT_FEE_CATEGORY_ID, INGREDIENT_CATEGORY_ID, INGREDIENT_OTHER_NOT_NEED_REQUEST } from "../../utils/Utils";
import { ModalBillVAT } from "./component/ModalBillVAT";
import { toast } from "react-toastify";

const ReportByCustomer = () => {
  const printRef = useRef();
  const {
    customerId
  } = useParams();
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [updatedAt, setUpdatedAt] = useState();
  const [customer, setCustomer] = useState();
  const [popupCustomerFlow, setPopupCustomerFlow] = useRecoilState(popupCustomerFlowAtom);
  const [smOption, setSmOption] = useState(false);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [ingredientOptions, setIngredientOptions] = useState([]);
  const [rangeDate, setRangeDate] = useState({
    start: searchParams.get('start') ? moment(searchParams.get('start')).startOf('days').toDate() : moment().startOf("months").toDate(),
    end: searchParams.get('end') ? moment(searchParams.get('end')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });
  const [selectedBillIds, setSelectedBillIds] = useState([]);
  const [showModalBillVAT, setShowModalBillVAT] = useState(false);
  // VAT gia công: gộp đơn nhận gia công theo nguyên liệu + đơn giá gia công
  const [isProcessingVAT, setIsProcessingVAT] = useState(false);
  const [amount, setAmount] = useState(0);
  const [filter, setFilter] = useState({
    warehouseId: searchParams.get("warehouseId") || undefined,
    excludeIngredientId: searchParams.getAll("excludeIngredientId") || [],
  });

  useEffect(() => {
    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
    GET("ingredient", {}, true).then((resp) => {
      setIngredientOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, []);

  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({ start: start ? moment(start)?.startOf('days').toDate() : start, end: end ? moment(end)?.endOf('days').toDate() : end });
    if (start && end) {
      setUpdatedAt(moment().valueOf());
    }
  };

  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
    });
    filter.excludeIngredientId?.forEach((id) => newParams.append("excludeIngredientId", id));
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    GET(
      `/customer/report-by-customer`,
      {
        fromDate: moment(rangeDate.start).format('YYYY-MM-DD'),
        toDate: moment(rangeDate.end).format('YYYY-MM-DD'),
        customerId,
        ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
        ...(filter.excludeIngredientId?.length > 0 ? { excludeIngredientId: filter.excludeIngredientId } : {}),
      },
      true
    ).then((resp) => {
      const { data } = resp;
      setData(data.rows);
      setSummary(data.summary);
    });
  }, [updatedAt, filter, popupCustomerFlow.updatedAt]);

  useEffect(() => {
    GET(`customer/${customerId}`, {}, true)
      .then(({ data }) => {
        setCustomer(data);
      })
  }, [])

  const availableBillIdForSelected = useMemo(() => {
    return data.filter(e => !!e.bill && !e.bill.isCreatedVatBill && e.bill.ingredientId !== 'VAT').sort().map(e => e.billId);
  }, [data])

  const isSelectedAllAvailableBillId = useMemo(() => {
    return selectedBillIds?.length > 0 && JSON.stringify(availableBillIdForSelected) === JSON.stringify(selectedBillIds);
  }, [availableBillIdForSelected, selectedBillIds])

  const colTable = [
    {
      id: 'select',
      Header: () => <div className="d-flex justify-content-center align-items-center cursor-pointer" style={{
        width: 13,
        height: 13,
        ...(isSelectedAllAvailableBillId || selectedBillIds.length ? { backgroundColor: '#0275ff' } : {
          border: '1px solid #767676'
        })
      }}
        onClick={isSelectedAllAvailableBillId ? () => { setSelectedBillIds([]) } : () => { setSelectedBillIds(availableBillIdForSelected); }}

      >
        <span style={{ color: 'white', fontSize: 12 }}>
          {isSelectedAllAvailableBillId ? '✓' : (selectedBillIds.length > 0 ? '-' : '')}

        </span>
      </div>,

      accessor: (item) => availableBillIdForSelected.includes(item.billId) && <Input
        type="checkbox"
        className="ml-0"
        checked={selectedBillIds.includes(item.billId)}
        onClick={() => {
          toggleSelectBill(item.billId)
        }}
      />,
    },
    {
      Header: "Mã",
      accessor: (item) => <strong
        className="cursor-pointer text-primary"
        onClick={() => {
          console.log('item', item);
          if (item.billId) {
            const ingredientId = item?.bill?.ingredientId;
            if (!!EXTERNAL_PORT_FEE_CATEGORY_ID[ingredientId]) {
              history.push(`/bill-external-port-fee/${item.billId}`)
            } else if (!!INGREDIENT_CATEGORY_ID[ingredientId]) {
              history.push(`/bill/${item.billId}`)
            } else if (!!INGREDIENT_OTHER_NOT_NEED_REQUEST[ingredientId]) {
              history.push(`/bill-other/${item.billId}`)
            } else {
              history.push(`/bill-other-must-request/${item.billId}`)
            }
          } else {
            setPopupCustomerFlow({
              show: true,
              data: {
                id: item.id,
                type: item.type,

              },
            });
          }
        }}>{item.id}</strong>,
    },
    {
      Header: "Ngày",
      accessor: (item) => item.date,
    },
    {
      Header: "Tài khoản",
      accessor: (item) => item.bankAccount?.name,
    },
    {
      Header: "Chứng từ",
      accessor: (item) => item?.bill?.truckId,
    },
    {
      Header: "Nội dung",
      accessor: "content",
    },
    {
      Header: "DVT",
      accessor: (item) => item?.bill ? 'Kg' : '',
    },
    {
      Header: "Số lượng(kg)",
      className: 'text-right',
      accessor: (item) => item?.bill ? <NumericFormat
        displayType={"text"}
        value={item?.bill?.finalMerchandiseWeight || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      /> : ''
    },
    {
      Header: "Đơn giá(đ)",
      sortable: true,
      className: 'text-right',
      accessor: (item) => item?.bill ? <NumericFormat
        displayType={"text"}
        value={item?.bill?.unitPrice || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      /> : ''
    },
    {
      Header: "Tỉ giá bán",
      sortable: true,
      className: 'text-right',
      accessor: (item) => item?.bill?.currency === 'USD' ? <NumericFormat
        displayType={"text"}
        value={item?.bill?.exchangeRate || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      /> : ''
    },
    {
      Header: "Thành tiền(đ)",
      className: 'text-right',
      accessor: (item) => item?.bill ? <NumericFormat
        displayType={"text"}
        value={item?.bill?.finalMerchandiseAmount || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      /> : ''
    },
    {
      Header: "Tăng(đ)",
      className: 'text-right',
      accessor: (item) => item.calculatedAmount > 0 ? <NumericFormat
        displayType={"text"}
        value={item.calculatedAmount || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      /> : ''
    },
    {
      Header: "Giảm(đ)",
      className: 'text-right',
      accessor: (item) => item.calculatedAmount < 0 ? <NumericFormat
        displayType={"text"}
        value={Math.abs(item.calculatedAmount || 0)}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      /> : ''
    },
    {
      Header: "Số dư(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.lessDebt || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Ghi chú",
      accessor: (item) => item.note
    },
    {
      Header: "Đơn giá($)",
      className: 'text-right',
      accessor: (item) => item?.bill?.unitPriceUSD ? <NumericFormat
        displayType={"text"}
        value={item?.bill?.unitPriceUSD || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={4}
      /> : ''
    },

    {
      Header: "Thành tièn đơn($)",
      className: 'text-right',
      accessor: (item) => item?.bill?.finalMerchandiseAmountUSD ? <NumericFormat
        displayType={"text"}
        value={item?.bill?.finalMerchandiseAmountUSD}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={4}
      /> : ''
    },
    {
      Header: "Thành tiền($)",
      className: 'text-right',
      accessor: (item) => item?.amountUSD ? <NumericFormat
        displayType={"text"}
        value={item?.amountUSD || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={4}
      /> : ''
    },
    {
      Header: "Tỉ giá thu",
      className: 'text-right',
      accessor: (item) => !item?.bill && item.currency === 'USD' ? <NumericFormat
        displayType={"text"}
        value={item?.exchangeRate || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={4}
      /> : ''
    },
  ];

  const toggleSelectBill = (billId) => {
    setSelectedBillIds((prev) => {
      if (prev.includes(billId)) {
        return prev.filter((id) => id !== billId);
      } else {
        return [...prev, billId].sort();
      }
    })
  }

  const exportExcel = () => {
    const params = new URLSearchParams({
      fromDate: moment(rangeDate.start).format("YYYY-MM-DD"),
      toDate: moment(rangeDate.end).format("YYYY-MM-DD"),
      customerId,
      token: getToken(),
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
    })
    filter.excludeIngredientId?.forEach((id) => params.append("excludeIngredientId", id));
    const url = `${process.env.REACT_APP_API_URL}/api/v1/customer/report-by-customer-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="Báo cáo"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">

                    <li>
                      <div className="form-group">
                        <div
                          className="form-control-wrap"
                          style={{ width: "200px" }}
                        >

                          <DatePicker
                            selected={rangeDate.start}
                            startDate={rangeDate.start}
                            onChange={onRangeChange}
                            endDate={rangeDate.end}
                            maxDate={new Date()}
                            selectsRange
                            className="form-control date-picker"
                          />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="form-group">
                        <div className="form-control-wrap">
                          <RSelect
                            isClearable
                            placeholder={"Lọc theo kho"}
                            options={warehouseOptions}
                            value={warehouseOptions.find((c) => c.value === filter.warehouseId) || null}
                            onChange={(val) => {
                              setFilter({
                                ...filter,
                                warehouseId: val?.value || undefined,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="form-group">
                        <div className="form-control-wrap" style={{ width: "220px" }}>
                          <RSelect
                            isClearable
                            isMulti
                            placeholder={"Loại trừ hàng hoá"}
                            options={ingredientOptions}
                            value={ingredientOptions.filter((c) => filter.excludeIngredientId?.includes(c.value))}
                            onChange={(val) => {
                              setFilter({
                                ...filter,
                                excludeIngredientId: val?.map((c) => c.value) || [],
                              });
                            }}
                          />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap">
                        <ReactToPrint
                          trigger={() => <Button>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button onClick={exportExcel} className="ml-3">
                          Xuất excel
                        </Button>
                        <Button
                          className="ml-3"
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <span>Trở về</span>
                        </Button>
                        {selectedBillIds.length > 0 && <Button
                          className="ml-3 btn-info"
                          onClick={() => {
                            setShowModalBillVAT(true)
                            setAmount(data.filter(e => selectedBillIds.includes(e.billId)).reduce((sum, curr) => sum + (curr?.bill?.finalMerchandiseAmount || 0), 0));
                          }}
                        >
                          <span>Tạo VAT</span>
                        </Button>}
                        {selectedBillIds.length > 0 && <Button
                          className="ml-3 btn-warning"
                          onClick={() => {
                            const selectedRows = data.filter(e => selectedBillIds.includes(e.billId));
                            if (selectedRows.some(e => !e?.bill?.isProcessing)) {
                              toast.error("Chỉ chọn các đơn nhận gia công để tạo VAT gia công");
                              return;
                            }
                            setIsProcessingVAT(true);
                            setShowModalBillVAT(true);
                            setAmount(selectedRows.reduce((sum, curr) => sum + (curr?.bill?.finalMerchandiseAmount || 0), 0));
                          }}
                        >
                          <span>Tạo VAT Gia công</span>
                        </Button>}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div
            id="DataTables_Table_1_wrapper"
            className="dataTables_wrapper dt-bootstrap4 no-footer bg-white"
          >
            <div className="row justify-between g-2">
              <div className="col-8 col-sm-6 text-start"></div>
              <div className="col-5 col-sm-6 text-end">
                <div className="datatable-filter">
                  <div className="d-flex justify-content-end g-2">
                    <div
                      className="dataTables_length"
                      id="DataTables_Table_1_length"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="my-3">
              <Row>
                <Col md={12} >
                  <div ref={printRef}>
                    <h5 className="text-center mt-2 mb-2">Báo cáo công nợ chi tiết {customer?.name}</h5>
                    <h6 className="text-center mt-2 mb-2">Từ {moment(rangeDate.start).format('DD-MM-YYYY')} đến {moment(rangeDate.end).format('DD-MM-YYYY')} </h6>
                    <Table
                      columns={colTable}
                      data={data}
                      notShowPagi={true}
                      headerRow={<><tr className="font-weight-bold">
                        <td colSpan={4}></td>
                        <td>Tồn đầu kì(đ)</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary.firstDebt || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                        <tr className="font-weight-bold">
                          <td colSpan={4}></td>
                          <td>Số phát sinh</td>
                          <td></td>
                          <td></td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.weight || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td></td>
                          <td></td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.amount || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.increaseAmount || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={Math.abs(summary.decreaseAmount || 0)}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={(summary.totalDebt) || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr className="font-weight-bold">
                          <td colSpan={4}></td>
                          <td>Tồn cuối kì(đ)</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.lastDebt || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </>}
                    ></Table>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Block>
        {
          showModalBillVAT && <ModalBillVAT
            amount={amount}
            customerId={customerId}
            selectedBillIds={selectedBillIds}
            isProcessing={isProcessingVAT}
            onCancel={() => {
              setShowModalBillVAT(false)
              setIsProcessingVAT(false);
              setAmount(0);
            }}
            onSuccess={() => {
              setAmount(0);
              setIsProcessingVAT(false);
              setShowModalBillVAT(false);
              setUpdatedAt(moment().valueOf());
              setSelectedBillIds([]);
            }}
          />
        }
      </Content>
    </React.Fragment>
  );
};

export default ReportByCustomer;
